'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.Service = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var BaseService_1 = require('./BaseService');
var injectable_1 = require('../decorators/injectable');
var OperationService_1 = require('./OperationService');
var Service = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Service, _super);
    function Service(operationService) {
        var _this = _super.call(this) || this;
        _this._operationsService = operationService;
        return _this;
    }
    Service.prototype.destroy = function () {
        var _i;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            typed_redux_saga_1.call.apply(
                                void 0,
                                (0, tslib_1.__spreadArray)(
                                    [[this, _super.prototype.destroy]],
                                    (0, tslib_1.__read)(args),
                                    false
                                )
                            )
                        ),
                    ];
                case 1:
                    _a.sent();
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)(
                            (0, typed_redux_saga_1.call)(this._operationsService.unregisterConsumer, this)
                        ),
                    ];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    };
    Service = (0, tslib_1.__decorate)(
        [
            (0, tslib_1.__param)(0, (0, injectable_1.inject)(OperationService_1.OperationService)),
            (0, tslib_1.__metadata)('design:paramtypes', [OperationService_1.OperationService]),
        ],
        Service
    );
    return Service;
})(BaseService_1.BaseService);
exports.Service = Service;
